import { SmsTemplates } from "./sms-templates";

export class SmsConfiguration {
    public id: number;
    public locationId: number;
    public systemId: number;
    public sender: string;
    public smsTemplatesJson: string;
    public smsTemplates: SmsTemplates;
}